import { useState, useCallback } from 'react';

/**
 * Hook customizado para controlar a exibição de dicas persistidas no localStorage.
 * @param key Chave exclusiva para identificar o status de visualização da dica.
 */
export function useTooltipTip(key: string) {
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    try {
      return localStorage.getItem(`tooltip_dismissed_${key}`) !== 'true';
    } catch (e) {
      console.error('Falha ao ler localStorage:', e);
      return true;
    }
  });

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(`tooltip_dismissed_${key}`, 'true');
      setIsVisible(false);
    } catch (e) {
      console.error('Falha ao gravar no localStorage:', e);
    }
  }, [key]);

  return { isVisible, dismiss };
}
